/* unplugin-vue-components disabled */import script from "./NotificationPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./NotificationPanel.vue?vue&type=script&setup=true&lang=js"

import "./NotificationPanel.vue?vue&type=style&index=0&id=db740d0e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-db740d0e"]])

export default __exports__